import { render, staticRenderFns } from "./emailVerification.vue?vue&type=template&id=040c4da0&scoped=true"
import script from "./emailVerification.vue?vue&type=script&lang=js"
export * from "./emailVerification.vue?vue&type=script&lang=js"
import style0 from "./emailVerification.vue?vue&type=style&index=0&id=040c4da0&prod&lang=less"
import style1 from "./emailVerification.vue?vue&type=style&index=1&id=040c4da0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040c4da0",
  null
  
)

export default component.exports